module.exports = __webpack_public_path__ + "img/yitihua.f6e85969.png";